import { TrackingError } from '@/domain/errors/tracking-error'
import { trackEvent } from '@/infra/tracking/analytics'
import errorMonitor from '@/infra/tracking/error-monitor'
import PathConstants from '@/main/routes/path-contants'

/* eslint-disable @typescript-eslint/no-explicit-any */
export const safeTrackCall = (fn: (...args: any[]) => void): ((...args: any[]) => void) => {
  return async function (...args: any[]) {
    try {
      fn(...args)
    } catch (error) {
      errorMonitor.captureException(new TrackingError(error))
    }
  }
}

const parseStringNameRoute = (value?: string | PathConstants.RouteProps) => {
  return typeof value === 'string' ? value : value?.name
}

const parseStringTitleRoute = (value?: string | PathConstants.RouteProps) => {
  return typeof value === 'string' ? value : value?.title
}

export namespace CommonAnalytics {
  export const trackBreadcrumb = safeTrackCall(
    async (
      destination: string | PathConstants.RouteProps,
      origin: string | PathConstants.RouteProps,
      source?: string | PathConstants.RouteProps
    ) => {
      if (!destination) return

      trackEvent('up_breadcrumb_navigate', {
        destination: parseStringNameRoute(destination),
        origin: parseStringNameRoute(origin),
        source: source ? parseStringTitleRoute(source) : parseStringTitleRoute(destination)
      })
    }
  )
}
